import React from "react";

/**
 * FrontierMark — the house logo. Two sizes, with optional tagline.
 * Cobalt serif F rhymes with italic accent words. Inter Black wordmark
 * matches the display headlines. JetBrains Mono for the POWERED BY tag.
 */
export default function FrontierMark({ size = "md", showTagline = true, className = "" }) {
    const scale = {
        sm: { f: 26, divider: 22, word: 15, sub: 7 },
        md: { f: 44, divider: 38, word: 26, sub: 8.5 },
        lg: { f: 72, divider: 64, word: 44, sub: 11 },
    }[size];

    return (
        <div className={`flex items-center gap-3 ${className}`} data-testid="frontier-mark">
            <span
                style={{
                    fontFamily: "'Fraunces', serif",
                    fontWeight: 700,
                    color: "var(--cobalt)",
                    fontSize: scale.f,
                    lineHeight: 0.9,
                    letterSpacing: "-0.02em",
                }}
            >
                F
            </span>
            <span
                style={{
                    width: 1,
                    height: scale.divider,
                    background: "var(--rule)",
                }}
            />
            <div className="flex flex-col gap-[2px] leading-none">
                <span
                    style={{
                        fontFamily: "'Inter', sans-serif",
                        fontWeight: 900,
                        color: "var(--ink)",
                        fontSize: scale.word,
                        letterSpacing: "-0.035em",
                        lineHeight: 1,
                    }}
                >
                    Frontier
                </span>
                {showTagline ? (
                    <span
                        style={{
                            fontFamily: "'JetBrains Mono', monospace",
                            fontWeight: 500,
                            fontSize: scale.sub,
                            letterSpacing: "0.28em",
                            color: "var(--muted)",
                            textTransform: "uppercase",
                        }}
                    >
                        Powered by M1C
                    </span>
                ) : null}
            </div>
        </div>
    );
}
